import axios from 'axios'

export const AdminStateService = {
  /**
   * Fetch state records
   */
  fetchStateList (data, status) {
    let queryParams = '?'
    if (data !== undefined && data !== '') {
      queryParams += `cId=${data}&`
    }
    if (status !== undefined && status !== '') {
      queryParams += `status=${status}`
    }
    return axios.get(`/api/v1/statelist${queryParams}`)
  },
  searchStateItem (data) {
    return axios.get(`/api/v1/statelist`, {
      params: {
        cId: data.countryId,
        status: data.fstatus,
        fips: data.fipsId,
        id: data.stateId
      }
    })
  },
  fetchStateFips () {
    return axios.get(`/api/v1/statefips`)
  },
  addStateItem (data) {
    return axios.post(
      `/api/v1/addstate`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    )
  },
  editStateItem (data) {
    return axios.post(
      `/api/v1/editstate`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    )
  },
  addLocalStateAdoption (data) {
    return axios.post(`/api/v1/addlocalstateadoption`, JSON.stringify({
      iCodeIds: data.id, // Selected i-code abbreviation
      stateId: data.adoptionLevelFor, // state entity id
      userId: data.userId // login user id
    }))
  },
  fetchStateDetailsById (id) {
    let queryParams = '?'
    if (id > 0) {
      queryParams += `sId=${id}`
    }
    return axios.get(`/api/v1/state${queryParams}`)
  },
  fetchLocalICodeAdoptionById (id, userId) {
    let queryParams = '?'
    if (id > 0) {
      queryParams += `sId=${id}&uId=${userId}`
    }
    return axios.get(`/api/v1/getlocaladoptionbystateid${queryParams}`)
  },
  validateDeleteStateProfile (Data) {
    return axios.delete(`/api/v1/deletestate`, { data: Data })
  },
  deleteStateProfile (Data) {
    return axios.delete(`/api/v1/deletestate`, { data: Data })
  }
}
